export default {
  groupBy: <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
    arr.reduce((groups, item) => {
      (groups[key(item)] ||= []).push(item);
      return groups;
    }, {} as Record<K, T[]>),

  arrayRange: (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (value, index) => start + index * step),
  isEmptyOrSpaces(str: string) {
    return str === null || str.match(/^\s*$/) !== null;
  }
};
